import { render, staticRenderFns } from "./customSelect.vue?vue&type=template&id=1edbeb20&scoped=true"
import script from "./customSelect.vue?vue&type=script&lang=js"
export * from "./customSelect.vue?vue&type=script&lang=js"
import style0 from "./customSelect.vue?vue&type=style&index=0&id=1edbeb20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edbeb20",
  null
  
)

export default component.exports